module.exports = __webpack_public_path__ + "img/2012-12-14 18.18.57.1d2f95be.jpg";